import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";

export interface AdminUser {
  id: string;
  name?: string;
  email: string;
  profilePictureLink?: string;
  linkedIn?: string;
  phoneNumber?: string;
  marketingConsent: boolean;
  tosVersionAgreement?: string;
  isAdmin: boolean;
}

export interface UsersPage {
  rows: AdminUser[];
  total: number;
}

export interface UsersQueryParams {
  limit: number;
  offset: number;
  filter?: string; // search term
  sortField?: "name";
  sortDirection?: "asc" | "desc";
}

export const useAdminUsersQuery = (params: UsersQueryParams) => {
  const { getAccessTokenSilently } = useAuth0();

  const { data, error, isLoading, isFetching } = useQuery<UsersPage>({
    queryKey: QueryKeys.adminUsers(params),
    enabled: !!params,
    refetchOnWindowFocus: false,
    placeholderData: (prev) => prev,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();

      return await request<UsersPage>({
        method: "GET",
        path: "/api/admin/users",
        token,
        params: params as unknown as Record<string, unknown>,
      });
    },
  });

  return {
    adminUsersPage: data,
    adminUsersError: error,
    adminUsersLoading: isLoading,
    adminUsersFetching: isFetching,
  };
};
